import { useState } from 'react';

import Heading from '@zenbusiness/zui/Heading';
import LoadingButton from '@zenbusiness/zui/LoadingButton';
import Radio from '@zenbusiness/zui/Radio';
import RadioGroup from '@zenbusiness/zui/RadioGroup';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { FocusGrid, ContainerGrid, ActionTwoButtonsGrid } from '#client/components/Grid';
import { CARD_STATUS } from '#client/constants/cards';
import useEnterSubmit from '#client/hooks/useEnterSubmit';
import useFormStep from '#client/hooks/useFormStep';

import {
  BoxContentStyled,
  DialogContentStyled,
  FormControlLabelStyled,
  Wrapper
} from './CustomModal.styles';

import { SENDING_ADDRESS, CHOOSE_CARD, REASON } from '../constants/card';

export default function ReasonOfRequestingFrom() {
  const { setCurrentFormStep, data, setData } = useFormStep();
  const { reason } = data;
  const [reasonOfRequestingSelected, setReasonOfRequestingSelected] = useState(reason);
  const nextButtonId = useEnterSubmit();

  const enableSuspectedFraudStatusFeature = data?.cardStatus === CARD_STATUS.SUSPECTED_FRAUD;

  const hideDamageCardOption =
    enableSuspectedFraudStatusFeature || data?.cardStatus === CARD_STATUS.FROZEN;

  const handleSubmit = () => {
    setData({
      ...data,
      reason: reasonOfRequestingSelected
    });

    setCurrentFormStep(SENDING_ADDRESS);
  };

  const handleBack = () => {
    setCurrentFormStep(CHOOSE_CARD);
  };

  const handleChange = (e, value) => {
    setReasonOfRequestingSelected(value);
  };
  return (
    <>
      <DialogContentStyled>
        <ContainerGrid>
          <FocusGrid>
            <Wrapper spacing="32px">
              <Stack spacing="16px">
                <Heading
                  family="secondary"
                  size="3xl"
                  weight="bold"
                >
                  Why do you need a new card?
                </Heading>
                <Text
                  color="primary"
                  size="lg"
                >
                  If your card was damaged, the replacement card will have the same card number,{' '}
                  expiration, and PIN, with a new security code (CVV).
                </Text>
              </Stack>
              <BoxContentStyled>
                <RadioGroup
                  aria-label="Choose reason for requesting a new card."
                  name="reason-radio-buttons-group"
                  onChange={handleChange}
                  sx={{
                    gap: '32px'
                  }}
                  value={reasonOfRequestingSelected}
                >
                  <FormControlLabelStyled
                    control={<Radio />}
                    label={
                      <Text
                        color="primary"
                        size="xl"
                        weight="medium"
                      >
                        My card is lost
                      </Text>
                    }
                    value={REASON.LOST}
                  />
                  <FormControlLabelStyled
                    control={<Radio />}
                    label={
                      <Text
                        color="primary"
                        size="xl"
                        weight="medium"
                      >
                        My card is stolen
                      </Text>
                    }
                    value={REASON.STOLEN}
                  />
                  {!hideDamageCardOption && (
                    <FormControlLabelStyled
                      control={<Radio />}
                      label={
                        <Text
                          color="primary"
                          size="xl"
                          weight="medium"
                        >
                          My card is damaged
                        </Text>
                      }
                      value={REASON.DAMAGED}
                    />
                  )}
                </RadioGroup>
              </BoxContentStyled>
            </Wrapper>
          </FocusGrid>
        </ContainerGrid>
      </DialogContentStyled>
      <ActionTwoButtonsGrid
        firstButton={
          <LoadingButton
            fullWidth
            onClick={handleBack}
            size="large"
            variant="outlined"
          >
            Back
          </LoadingButton>
        }
        secondButton={
          <LoadingButton
            color="primary"
            disabled={!reasonOfRequestingSelected}
            fullWidth
            id={nextButtonId}
            onClick={handleSubmit}
            size="large"
            variant="contained"
          >
            Next
          </LoadingButton>
        }
      />
    </>
  );
}
